export default function Export(clz) {
  return class extends clz {
    toCSV(delimter = ";", all = true, exportcolumns){
      let result = "#";
      let columns = all ? this.columns : this.renderingColumns;

      if(exportcolumns){
        columns = columns.filter(col => exportcolumns.includes(col.field))
      }

      columns.forEach((col, i) => {
        result += `${i===0 ? "" :";"}${col.label}`;
      })
      result += "\r\n"
      this.data.forEach(item => {
        columns.forEach((col, i) => {
          result += i===0 ? "" : delimter
          result += col.renderCell ? col.renderCell(item) : item[col.field];
        })
        result += "\r\n"
      })
      return result;
    }
  };
}
